<template>
    <div class="regular fullBg">
        <div class="rightWeekData">
            <div class="headP">
                <p class="img"><img
                    :src="infoMesData?infoMesData.avatar:require('@/assets/img/updateImg/playerHead.png')" alt="">
                </p>
                <p class="name">
                    <span class="zh">{{ infoMesData ? infoMesData.name : '' }}</span>
                    <span class="en">{{ infoMesData ? infoMesData.nameEn : '' }}</span>
                </p>
                <p class="position">
                    <i><img :src="require('@/assets/img/playerImg/'+$route.params.position+'.svg')" alt=""></i>
                </p>
                <p class="playerMsg" v-if="barDate">
                    <span class="star">{{ barDate }}</span>
                </p>
            </div>
            <div id="networkDiagram" class="message" style="height: 12vw;width:35vw;"></div>
            <div class="barTit">
                <template v-for="item in colorObj">
                   <span class="titCol"
                         :style="{background: 'linear-gradient(180deg,'+item.start+' 0%, '+item.end+' 100%)'}"></span>
                    <span class="titLab">{{ item.name }}</span>
                </template>
            </div>
            <div id="weekBar" style="height: calc(100% - 11vw);  width: 90%;clear: both"></div>
        </div>
    </div>
</template>

<script>
export default {
    name: "assessmentReportDetail",
    props: {
        // trainingReportId: String
    },
    data() {
        return {
            trainingReportId: this.$route.params.id,//球员id
            // trainingReportId: '60f5098424df485358d8f740',//球员id
            // seasonId: this.$route.params.seasonId,//赛季id
            infoMesData: null,//初始化的数据
            playersReportList: null,//球员获取评估项

            workDiagram: {},//雷达图各项数据
            dateBar: {},//柱状图各项数据
            barLin: 55,//柱状图显示个数
            barDate: '',//柱状图时间

            timeInfo: null,//定时器--首次加载
            timer: null,//定时器--间隔加载

            colorObj: [
                {
                    name: '技术Technical',
                    start: "#FFB23E",
                    end: "#FFD02B",
                    key: "Technical"
                },
                {
                    name: '战术Tactical',
                    start: "#2979FF",
                    end: "#42A5F5",
                    key: "Tactical"
                }, {
                    name: '身体Physical',
                    start: "#34C955",
                    end: "#85C934",
                    key: "Physical"
                }, {
                    name: '精神Spirit',
                    start: "#E65045",
                    end: "#E98680",
                    key: "Spirit"
                }
            ],
        }
    },
    mounted() {
        this.infoFn();
    },
    watch: {},
    methods: {
        //初始化数据
        //初始化数据
        infoFn() {
            let data = {
                id: this.trainingReportId,//球员id
                info: 'personal'
            }
            this.$server.getUserMsg(data).then((res) => {
                this.infoMesData = res.data;
                console.log(this.infoMesData)
                //柱状图
                data = {
                    playerId: this.trainingReportId,//球员id
                    start: new Date().getFullYear() + '/01/01',
                    end: this.$global.formatDate(new Date(), 'yyyy/MM/dd', true)
                }
                this.$server.getPlayersReportWeekAll(data).then((res) => {
                    this.playersReportList = res.data;
                    if (this.playersReportList.length) {
                        let barWidth = 13;//柱状图默认宽度
                        clearInterval(this.timer);
                        this.weekBarData(res.data[0], barWidth);
                        let indexNum = 0;
                        this.timer = setInterval(() => {
                            indexNum++;
                            if (barWidth === 13) {
                                barWidth = 5
                            }else {
                                barWidth = 13
                            }
                            if (!this.playersReportList[indexNum]) {
                                indexNum = 0;
                            }
                            this.weekBarData(res.data[indexNum], barWidth);
                        },10000)
                    }
                });
                this.$parent.$parent.imgAi(this.$imgJson.handAiImgArr);
                this.$parent.$parent.audioPlayFn(this.$global.audioPlayUrl("这是" + this.infoMesData.name + this.$global.randomFn(this.$aiJson.playVoice.reportDetail)), true, false)
            })
        },
        //网络图
        networkDiagram(data) {
            // data = JSON.parse(data);
            let indicatorArr = [
                {name: '技术', nameEn: 'Technical'},
                {name: '战术', nameEn: 'Tactical'},
                {name: '身体', nameEn: 'Physical'},
                {name: '精神', nameEn: 'Spirit'},
            ], seriesVal = [data.Technical, //技术
                data.Tactical, //战术
                data.Physical,//身体
                data.Spirit,//精神
            ]
            let myChart = this.$echarts.init(document.getElementById('networkDiagram'));
            myChart.setOption({
                title: {text: null}, // 隐藏图表标题
                legend: {enabled: false}, // 隐藏图例
                tooltip: {
                    trigger: 'axis'
                },
                calculable: true,
                radar: [
                    {
                        splitNumber: 4, // 雷达图圈数设置
                        nameGap: 5, // 图中工艺等字距离图的距离
                        // center: ['50%', '60%'], // 图的位置
                        shape: 'circle',
                        name: {
                            show: true, // 是否显示工艺等文字
                            formatter: (params, value) => {
                                let num;
                                let name;
                                for (let i = 0; i < indicatorArr.length; i++) {
                                    if (indicatorArr[i].name == params) {
                                        num = seriesVal[i];
                                        if (this.$store.state.language == 'en') {
                                            name = indicatorArr[i].nameEn
                                        } else {
                                            name = indicatorArr[i].name
                                        }
                                    }
                                }
                                let html = [
                                    '{label|' + name + ' ' + '}{num|' + ' ' + num + '}'
                                ]
                                return html;
                            }, // 工艺等文字的显示形式
                            rich: {
                                label: {
                                    color: '#979797',// 工艺等文字颜色
                                    fontSize: 18
                                },
                                num: {
                                    color: '#fff',
                                    fontSize: 24,
                                    fontFamily: 'akrobatBold'
                                },
                            },
                        },
                        indicator: indicatorArr,
                        axisLine: {            // 坐标轴线
                            show: true,        // 默认显示，属性show控制显示与否
                            lineStyle: {
                                color: '#383838', // 设置网格的颜色
                            },
                        },
                        splitArea: {
                            show: true,
                            areaStyle: {
                                // color: '#2A2C3B', // 图表背景的颜色
                                color: new this.$echarts.graphic.LinearGradient(0, 0, 1, 0, [{
                                    offset: 1,
                                    color: 'rgba(73, 73, 73, 0.54)'
                                },
                                    {
                                        offset: 0.5,
                                        color: 'rgba(51, 51, 51, 0.2)'
                                    },
                                    {
                                        offset: 0,
                                        color: 'rgba(73, 73, 73, 0.54)'
                                    }])
                            },
                        },
                        splitLine: {
                            show: true,
                            lineStyle: {
                                width: 1,
                                color: 'rgba(73, 73, 73, 0.54)', // 设置网格的颜色
                            },
                        }
                    }
                ],
                series: [
                    {
                        name: '维度数据',
                        type: 'radar',
                        symbol: "none", // 去掉图表中各个图区域的边框线拐点
                        itemStyle: {
                            normal: {
                                color: new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                    offset: 1,
                                    color: 'rgba(149, 70, 217, 0.2)'
                                },
                                ]),// 图表中各个图区域的边框线拐点颜色
                                lineStyle: {
                                    color: "#9546D9" // 图表中各个图区域的边框线颜色
                                },
                                areaStyle: {
                                    type: 'default'
                                }
                            }
                        },
                        data: [
                            {
                                value: seriesVal
                            },
                        ],
                    }
                ]
            });
        },
        //柱状图
        weekBarData(data, barWidth) {


            this.dateBar = this.serializationList(data);
            let barSeriesData = this.dateBar.showDataAll;
            this.workDiagram = this.dateBar.mean;
            // console.log(this.workDiagram)
            // console.log(this.dateBar)
            // console.log(barSeriesData)
            let thisBarDataX = [];//柱状图个数
            let thisBarData = [];//柱状图数据
            for (let i = 0; i < this.barLin; i++) {
                thisBarDataX.push(i);
                thisBarData.push(barSeriesData[i].data)
            }
            // console.log(thisBarDataX)
            // console.log(thisBarData)
            // 指定图表的配置项和数据
            let myChart = this.$echarts.init(document.getElementById('weekBar'));
            myChart.clear();

            myChart.setOption({
                grid: {
                    x: 40,
                    y: 10,
                    right: 0,
                    top: '10%',
                    borderWidth: 1
                },
                //  ------  X轴 ------
                xAxis: {
                    show: false,  // 是否显示
                    nameGap: 15, // 坐标轴名称与轴线之间的距离
                    nameRotate: 0,  // 坐标轴名字旋转
                    axisLine: {       // 坐标轴 轴线
                        show: true,  // 是否显示
                        // ------   线 ---------
                        lineStyle: {
                            color: '#616162',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {    // 坐标轴 刻度
                        show: false,  // 是否显示
                    },
                    type: 'category',
                    data: thisBarDataX
                },
                //   ------   y轴  ----------
                yAxis: {
                    show: false,  // 是否显示
                    nameTextStyle: {    // 坐标轴名称样式
                        color: '#fff',
                        padding: [5, 0, 0, 5]  // 坐标轴名称相对位置
                    },
                    nameGap: 15, // 坐标轴名称与轴线之间的距离

                    axisLine: {    // 坐标轴 轴线
                        show: true,  // 是否显示
                        // ----- 线 -------
                        lineStyle: {
                            color: '#616162',
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisTick: {      // 坐标轴的刻度
                        show: true,    // 是否显示
                        inside: true,  // 是否朝内
                        length: 3,      // 长度
                        lineStyle: {
                            color: '#616162',  // 默认取轴线的颜色
                            width: 1,
                            type: 'solid'
                        }
                    },
                    axisLabel: {      // 坐标轴的标签
                        show: true,    // 是否显示
                        inside: false,  // 是否朝内
                        rotate: 0,     // 旋转角度
                        margin: 8,     // 刻度标签与轴线之间的距离
                        color: '#fff',  // 默认轴线的颜色
                    },
                    splitLine: {    // gird 区域中的分割线
                        show: true,   // 是否显示
                        lineStyle: {
                            color: '#666',
                            width: 1,
                            type: 'solid'
                        }
                    },
                },
                //  -------   内容数据 -------
                series: [
                    {
                        type: 'bar',      // 类型
                        label: {
                            show: true,
                            position: 'top',
                            distance: 15,
                            align: 'left',
                            verticalAlign: 'middle',
                            rotate: 90,
                            formatter: (ind) => {
                                let title = barSeriesData[ind.dataIndex].evaluationTemplateItem;
                                return title ? title.itemName : ''
                            },
                            fontSize: 12,
                            color: 'rgba(255,255,255,.35)',
                        },
                        itemStyle: {    // 图形的形状
                            normal: {
                                //柱形图圆角，初始化效果
                                barBorderRadius: [3, 3, 0, 0],
                                color: (params) => {
                                    return new this.$echarts.graphic.LinearGradient(0, 1, 0, 0, [{
                                        offset: 1,
                                        color: barSeriesData[params.dataIndex].start
                                    },
                                        {
                                            offset: 0,
                                            color: barSeriesData[params.dataIndex].end
                                        }])
                                }
                            }
                        },
                        barWidth: barWidth,  // 柱形的宽度
                        barGap: '10%',
                        // barCategoryGap: '20%',  // 柱形的间距

                        data: thisBarData,
                        markLine: {
                            symbol: ['none', 'none'],//去掉箭头
                            lineStyle: {
                                type: 'dotted',
                                color: 'rgba(207, 212, 217, .36)'
                            },
                            label: {
                                // position: 'insideStartTop'
                            },
                            data: [
                                {type: 'average', name: '平均值'}
                            ]
                        },//平均线
                        animationDelay:  (idx) => {
                            return idx * this.barLin*2;
                        }
                    }
                ]
            });

            this.networkDiagram(this.workDiagram);


        },

        //数据分类
        serializationList(list) {
            let data = list.evaluationDataMap;
            console.log(data)
            let dataAll = [];
            let showDataAll = [];
            this.colorObj.map(item => {
                if (data[item.key]) {
                    data[item.key].map(j => {
                        dataAll.push({
                            ...j,
                            ...item,
                        })
                    })
                }
            })

            if (dataAll.length < this.barLin) {
                let lengthNum = Math.ceil(this.barLin/dataAll.length);
                console.log(lengthNum)
                console.log(dataAll.length)
                for (let i = 0; i < lengthNum; i++) {
                    showDataAll.push(...dataAll)
                }
            }

            return {
                ...list,
                showDataAll,
            }
        },
        //问题分类
        positionScreen(data) {
            let map = {}
            for (let i = 0; i < data.length; i++) {
                map[data[i].key] = data[i]
            }
            // console.log(map);
            return map
        }
    },
    beforeDestroy() {
        clearInterval(this.timer);
        clearInterval(this.timeInfo);
    }
}
</script>

<style scoped lang="less">
.fullBg {
    background-image: url("../assets/img/updateImg/bg3.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
}

.rightWeekData {
    width: 75%;
    height: calc(100% - 8vw);
    margin-bottom: 3vw;
    padding: 5vw 8vw 0 5vw;
    box-sizing: border-box;
    float: left;
    position: relative;
    color: #fff;
}

.message {
    position: absolute;
    right: 10%;
    top: 10%;
}

.barTit {
    /*position: absolute;*/
    /*top: 14vw;*/
    /*right: 5vw;*/
    padding-bottom: 1vw;
    margin-right: 1vw;
    padding-top: 3vw;
    font-size: 22px;
    margin-top: 2vw;
    border-top: 1px solid rgba(255, 255, 255, .05);
    float: right;

    span {
        float: left;
    }

    .titCol {
        width: 24px;
        height: 24px;
        display: inline-block;
    }

    .titColXingGe {
        background: #F3C74E;
    }

    .titColJiShu {
        background: #71ABFB;
    }

    .titColZhanShu {
        background: #4BCC6E;
    }

    .titLab {
        font-family: PingFang;
        color: rgba(255,255,255,.8);
        padding-left: .5vw;
        padding-right: 1.5vw;
        margin-top: -5px;
    }
}

.headP {
    font-size: 44px;
    margin-top: 3vw;
    height: 8vw;
    /*line-height: 8vw;*/
    background-size: auto 100%;
    background-repeat: no-repeat;
    position: relative;

    .img {
        float: left;
        width: 7vw;
        height: 7vw;
        overflow: hidden;
        border-radius: 50%;
        background-color: rgba(12, 12, 13, 1);

        img {
            width: 100%;
        }
    }

    .name {
        padding-left: 3vw;
        float: left;
        font-family: PingFangMedium;

        span {
            display: block;
        }

        span.zh {
            font-weight: bolder;
            font-size: 60px;
            background: linear-gradient(180deg, #FFFFFF 0%, #CAC9C9 200%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }

        span.en {
            font-size: 30px;
            background: linear-gradient(180deg, rgba(255, 255, 255, .6) 0%, rgba(202, 201, 201, .6) 100%);
            -webkit-background-clip: text;
            -webkit-text-fill-color: transparent;
        }
    }

    .position {
        float: left;
        margin-left: 2vw;
        margin-top: 1.5vw;
    }

    .playerMsg {
        color: rgba(255, 255, 255, .8);
        position: absolute;
        right: -7.1vw;
        top: 3vw;
        margin-left: 2vw;
        text-align: left;
        margin-top: 1.5vw;
        font-size: 30px;

        .star {
            font-family: PingFangMedium;
            background-image: url("../assets/img/playerImg/bg2.svg");
            background-size: 100% auto;
            padding-right: 2vw;
            padding-left: 1vw;
            padding-top: .2vw;
            padding-bottom: .2vw;
            width: 13vw;
            display: inline-block;

            img {
                width: 1.5vw;
                height: 1.5vw;
                margin-right: 1vw;
            }
        }
    }
}


</style>
